import { ThemeArtwork } from '@src/theme/Artwork';
import type { BoxInfo } from '@lub0v/santa-utils';
import type { BoxView } from '@src/routing/routes';
import { MobileBoxNav } from './MobileBoxNav';
import './HangingBoxMenu.css';

export function HangingBoxMenu({ info, view }: { info: BoxInfo; view: BoxView }) {
  return (
    <div
      className={`hanging-box-menu${info.isAdmin ? '' : ' hanging-box-menu--compact'}`}
      data-testid="hanging-box-menu"
    >
      <ThemeArtwork
        role={info.isAdmin ? 'menu' : 'menu-compact'}
        className="hanging-box-menu__art"
      />
      <MobileBoxNav info={info} view={view} placement="inline" />
    </div>
  );
}
